var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var SvgPush = function SvgPush(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    fill: "currentColor",
    viewBox: "0 0 16 16",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M5.292 10.293a1 1 0 1 0 1.415 1.414l3-3a.997.997 0 0 0 0-1.414l-3-3a1 1 0 0 0-1.415 1.414L6.585 7H1a1 1 0 1 0 0 2h5.584l-1.293 1.293ZM14 6a2 2 0 1 0 0 4 2 2 0 0 0 0-4Z"
  })));
};
export default SvgPush;